var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "url(#pattern0_1604_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1604_2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1604_2",
    transform: "scale(0.0277778)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1604_2",
    width: 36,
    height: 36,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAADn0lEQVRYhcVYWU9TQRg9paWUgkhFEFxAiYq70Wgk0cQH/7QPJkbDg0skitEYIrIqCgKyCUJbzGnOJJ/DvXNvg8BJmna+mTtz7rdPEUAGQGPMdD5GHre+UfslIhtYcEuf7wD+GPkFAIMA1gCsGnk3gIc6eMHIWwE8AtAG4FsSoYbAHDfg5kVP3qLvI568aJ6zaNU5LUgBHvgAQCnN4n3CCoDnAHachg6TDKTRnBvkzMQzAGUzvid1jwCYN/IrAHoAfAEwbuRnAFzU2hEj7wRwQz730shz8rl/YAltANg2YzosCS0D+O3Je2LkkAmsfEnmWPfkkRGZixIKwwCaRNRiFMC0tzkUQb8i1pPgEwBbgbNSEapGbA69rU/GIU6+mYaMT+i+8/QDQmSitIT8vHIosIToM5UDPJtV4naI0JwXZfuNuqOsC8BJ/abmPnmEi6przhcmFeIOTLqXzcHMT1+TWIYInQfQYcY/AcyaMXNRr/eMJXQUQL8Zl/ZK6L0qeINyyA9vfsrswRQxE0HuHYBmRe9cEpkkQsy8q4F5mm8sYf+phPm6CLUDOOUdbqMwL5NkpYFJlQeHjPYoaW1FCXIhkECDhFhErQ+teQ1Wr5zaEnwrE58T2ULM3osqznURYlT16HclwgdmRMJF2bQi765p0qo6fEOabNXcMX3qIsSNFgPzVP9HMy6q/BTUxozKjGXvOa67ZNwhNSG2nF3SwLY0Ymsd3/i0vqvqhwrSxguZ2KFbfuNak2HlpZvavw/A5yRCbKqOm3HZy0Pc5Kr3TEVNmCXTJjNS9tTIp5U0uceAXngzRGjCqLvs3SSgvFSSE3dLNobdqcJl6qgbzrg0S9Jn6bchQtTGbGCeIf5GXYIjNBFYH4UdPUNrnEgixAhykVBW6bDIqF92Zl3x7m8+soY4pMl1sy+11BAixNag04xfeeWDKr5mxnFdoQuEvHzJgYHy2OtK80kmy5soW/HmF1WvCqpXcbfgZb1Isyd3Pmk5VEOEmEMmA/M8aEhmG5QvZSLa4Iq0GwfXqdIttvwW1k9iaeDqW17+NF/n867nqmnMb/L3igE5adrLQovpqZiXanZv1/2rusdP1vhSGi3lZOqCzF8rQ6n+s0mJfpO52Qd9CLgAi+wd4yZDLqGG/h+qF0vK2h1qX/uUpXf04k2q8Lz/X9eYZF7rxlvD/9SQA52U+YkHJr0A+ydb9/aFEOE6AfZT1Jb7C5BJkNHEQrrbzwD8Bf8A5Mffy6MOAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateTimeIcon);
export default __webpack_public_path__ + "static/media/date-time-icon.fad4f1cb0c2d068fa82436b76f559303.svg";
export { ForwardRef as ReactComponent };